import { Box, Button, FormControl, FormHelperText, Grid, Modal, Radio, RadioGroup, Typography, Card, CardContent, Divider, IconButton } from "@mui/material"
import { HttpRequest } from "../HttpRequest";
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import mpesaIcon from "../../images/mpesa.png";
import cardIcon from "../../images/card.png";
import { currencyconverter } from "../../utils/dateFormatter";
import { ArrowBack, CheckCircle, Payment, Phone, LocalOffer, Person, Email as EmailIcon, CheckCircleOutline } from '@mui/icons-material';
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import { ErrorAlert } from "../common/snackbar/error";
import { SuccessAlert } from "../common/snackbar/success";
import loadingIcon from "../../images/loading.svg";
import { useSelector } from "react-redux";

const base_url = process.env.REACT_APP_WEB_SOCKET_URL;

const EvoucherCheckout = ({ voucherData, setCheckout, setVoucherData }) => {
    const [mpesaStatus, setMpesaStatus] = useState(false);
    const [payCardStatus, setPayCardStatus] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [paymentMethodError, setPaymentMethodError] = useState(false);
    const [mpesaPhoneNumberError, setMpesaPhoneNumberError] = useState(false);
    const [mobileMoneyNumberError, setMobileMoneyNumberError] = useState(false);
    const [bankPaybillStatus, setBankPaybillStatus] = useState(false);
    const [mobileMoneyNumber, setMobileMoneyNumber] = useState('');
    const [mpesaPhoneNumber, setMpesaPhoneNumber] = useState('');
    const [buttonStatus, setButtonStatus] = useState(true);
    const [openOrderProcessing, setOpenOrderProcessing] = useState(false);
    const [orderCreated, setOrderCreated] = useState(false);
    const [orderCreatedDetails, setOrderCreatedDetails] = useState({});
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const [successShow, setSuccessShow] = useState({ state: false, message: "" })
    const [errorShow, setErrorShow] = useState({ state: false, message: "" })

    const navigate = useNavigate();

    const { colors, typography, buttons } = useSelector((state) => state.template);
    const primaryColor = colors?.primary || '#02b3ad';
    const headingsColor = colors?.headings || '#343434';
    const bodyFont = typography?.body || 'Poppins';
    const headingsFont = typography?.headings || 'Poppins';
    const buttonPrimaryColor = buttons?.primary || primaryColor;
    const buttonRadius = buttons?.borderRadius || 5;

    const checkPaymentStatus = async () => {
        await HttpRequest({
            method: 'GET',
            url: `/api/get_payment_methods_with_status`
        }).then((data) => {
            let banks = data?.response?.data?.find(method => method?.name === "Banks") ?? []
            let kcbBanks = banks?.paymentOptions?.find(method => method?.name === "KCB") ?? []
            const mpesaStatus = data.response?.data?.find(method => method.name === "Mpesa")?.status ?? false;
            const cardStatus = data.response?.data.find(method => method.name === "Card")?.status ?? false;
            const paybillStatus = kcbBanks?.kcb?.find(method => method?.name === "Mobile Money")?.status ?? false

            setMpesaStatus(mpesaStatus)
            setBankPaybillStatus(paybillStatus)
            setPayCardStatus(cardStatus)
        }).catch(() => {
        });
    }
    useEffect(() => {
        checkPaymentStatus();
    }, [])

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    const getCustomerProfile = () => {
        let customerId = secureLocalStorage.getItem("customerId") ?? secureLocalStorage.getItem("userId")
        HttpRequest({
            method: 'GET',
            url: `/api/get_parentcustomer_data?customerId=${customerId}`
        }).then((data) => {
            let customerData = data?.response?.data;
            setFirstName(customerData?.firstName);
            setLastName(customerData?.lastName);
            setEmail(customerData?.email);
            setPhone(customerData?.phone);
        }).catch(() => {
        });
    }
    useEffect(() => {
        getCustomerProfile();
    }, [])

    const validateField = (field, setError, isValidFunc) => {
        const isValid = field !== '' && isValidFunc(field);
        setError(!isValid);
        return isValid;
    };

    const isValidMpesaPhoneNumber = (phoneNumber) => {
        const phoneNumberRegex = /^254\d{9}$/;
        return phoneNumberRegex.test(phoneNumber);
    };

    const handleBack = () => {
        setCheckout(false);
        setVoucherData(null);
    }

    const validateForm = () => {
        const validationResults = {
            paymentMethod: validateField(paymentMethod, setPaymentMethodError, () => true),
            mpesaPhoneNumber: paymentMethod === 'mpesa' ? validateField(mpesaPhoneNumber, setMpesaPhoneNumberError, isValidMpesaPhoneNumber) : true,
            mobileMoneyNumber: paymentMethod === 'kcbpaybill' ? validateField(mobileMoneyNumber, setMobileMoneyNumberError, () => true) : true
        };
        const isFormValid = Object.values(validationResults).every(result => result);
        return isFormValid;
    };

    const voucherPayload = {
        expiryDate: voucherData?.voucherDetails?.endDate,
        phoneNumber: mpesaPhoneNumber || mobileMoneyNumber,
        recipients: [
            {
                amount: voucherData?.selectedVoucher?.voucherAmount,
                email: email,
                name: firstName + ' ' + lastName,
                phone: phone,
            }
        ],
        customerId: secureLocalStorage.getItem('customerId'),
        startDate: voucherData?.voucherDetails?.startDate,
        campaignId: voucherData?.voucherDetails?._id
    }

    const payButtonStatus = () => {
        setButtonStatus(true);
        if (voucherPayload?.campaignId !== '' && voucherPayload.expiryDate !== '' && paymentMethod !== '' && (mpesaPhoneNumber !== null || mobileMoneyNumber !== null)) {
            setButtonStatus(false);
        }
    };
    useEffect(() => {
        payButtonStatus();
    }, [voucherPayload?.expiryDate, paymentMethod, mpesaPhoneNumber, mobileMoneyNumber]);

    const handleSubmit = () => {
        const customerId = secureLocalStorage.getItem('customerId');
        if (!customerId) {
            navigate('/login');
        }
        let payload = voucherPayload
        const isValid = validateForm();

        if (isValid) {
            if (orderCreated) {
                sendStkPush(orderCreatedDetails);
                setOpenOrderProcessing(true);
            } else {
                HttpRequest({
                    method: 'POST',
                    url: `/api/v1/evoucher/createEvoucher`,
                    body: payload
                }).then((data) => {
                    if (data?.status === 200) {
                        setOpenOrderProcessing(true);
                        setOrderCreated(true);
                        setOrderCreatedDetails(data?.response?.data)
                        sendStkPush(data?.response?.data);
                    } else {
                        setErrorShow({ state: true, message: 'Failed to purchase voucher. Please try again.' });
                    }
                }).catch((error) => {
                    setErrorShow({ state: true, message: error?.message });
                });
            }
        }
    };

    const sendStkPush = (orderDetails) => {
        const payload = {
            amount: orderDetails.amount,
            orderID: orderDetails.batchNumber,
            businessID: secureLocalStorage.getItem('businessId'),
            type: "evoucher",
            phone: paymentMethod === 'mpesa' ? mpesaPhoneNumber : mobileMoneyNumber,
            paymentChanel: 'Web',
        }

        HttpRequest({
            method: 'POST',
            url: paymentMethod === 'mpesa' ? `/api/pushstk` : paymentMethod === 'kcbpaybill' ? `/api/v1/payments/initiate_kcb_stk_push` : paymentMethod === 'card' ? `/api/v1/payments/card/pay` : '',
            body: payload
        }).then((data) => {
            if (data.status === 200) {
                let orderId
                const paymentLink = data?.response?.data?.data?.invoiceInformation?.paymentLink;
                if (paymentMethod === 'mpesa' || paymentMethod === 'kcbpaybill') {
                    orderId = data?.response.data?.requestReferenceId;
                }
                if (paymentMethod === 'card') {
                    orderId = data?.response?.data?.data.invoiceInformation?.invoiceNumber;
                }
                if (paymentLink) {
                    const cacheBustedLink = `${paymentLink}?t=${new Date().getTime()}`;
                    setTimeout(() => {
                        window.open(cacheBustedLink);
                    }, 3000);
                }

                const socket = new WebSocket(base_url + '/notification/' + orderId);
                const fallback = setTimeout(() => {
                    setErrorShow({ state: true, message: 'Payment notification timed out.' });
                    socket.close();
                }, 10000);

                socket.addEventListener('message', function (event) {
                    const data = JSON.parse(event.data);
                    clearTimeout(fallback);
                    if (data?.status === "OK") {
                        setSuccessShow({ state: true, message: data?.message });
                    } else if (data?.status === "SUCCESS") {
                        setOpenOrderProcessing(false);
                        setShowSuccessModal(true);
                    } else {
                        setErrorShow({ state: true, message: data.statusMessage });
                        socket.close();
                        setOpenOrderProcessing(false);
                    }
                });
            } else {
                setErrorShow({ state: true, message: 'Failed to process voucher payments.' });
            }
        }).catch(() => {
        });
    }

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: '100vh',
                background: '#fbfbfb',
                padding: { xs: '20px', sm: '30px', md: '40px' },
            }}
        >
            <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
            <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />

            <Box sx={{ maxWidth: '1200px', margin: '0 auto' }}>
                {/* Back Button & Header */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2 }, marginBottom: { xs: 3, md: 4 } }}>
                    <IconButton
                        onClick={handleBack}
                        sx={{
                            background: 'linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%)',
                            color: primaryColor,
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                            transition: 'all 0.3s',
                            width: { xs: '40px', sm: '48px' },
                            height: { xs: '40px', sm: '48px' },
                            '&:hover': {
                                background: `linear-gradient(145deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`,
                                color: '#fff',
                                transform: 'translateX(-4px)',
                            },
                        }}
                    >
                        <ArrowBack sx={{ fontSize: { xs: 20, sm: 24 } }} />
                    </IconButton>
                    <Typography
                        sx={{
                            color: headingsColor,
                            fontSize: { xs: '20px', sm: '28px', md: '32px' },
                            fontWeight: 800,
                            fontFamily: headingsFont,
                        }}
                    >
                        Checkout
                    </Typography>
                </Box>

                <Grid container spacing={{ xs: 3, md: 4 }}>
                    {/* Left Column - Payment & Customer Info */}
                    <Grid item xs={12} lg={7}>
                        {/* Customer Information Card */}
                        <Card
                            sx={{
                                background: '#fff',
                                borderRadius: { xs: '16px', md: '20px' },
                                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.06)',
                                border: `2px solid ${primaryColor}10`,
                                marginBottom: 3,
                            }}
                        >
                            <CardContent sx={{ padding: { xs: '20px', sm: '28px' } }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2 }, marginBottom: { xs: 2, sm: 3 } }}>
                                    <Box
                                        sx={{
                                            background: `linear-gradient(135deg, ${primaryColor}15 0%, ${primaryColor}08 100%)`,
                                            borderRadius: { xs: '10px', sm: '12px' },
                                            padding: { xs: '10px', sm: '12px' },
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Person sx={{ fontSize: { xs: 24, sm: 28 }, color: primaryColor }} />
                                    </Box>
                                    <Typography
                                        sx={{
                                            color: headingsColor,
                                            fontSize: { xs: '16px', sm: '18px', md: '20px' },
                                            fontWeight: 700,
                                            fontFamily: headingsFont,
                                        }}
                                    >
                                        Customer Information
                                    </Typography>
                                </Box>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Box>
                                            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#707070', marginBottom: 0.5, fontFamily: bodyFont }}>
                                                Full Name
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 600, color: headingsColor, fontFamily: bodyFont }}>
                                                {firstName} {lastName}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box>
                                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#707070', marginBottom: 0.5, fontFamily: bodyFont }}>
                                                    Email
                                                </Typography>
                                                <Typography sx={{ fontSize: '15px', fontWeight: 600, color: headingsColor, fontFamily: bodyFont, wordBreak: 'break-all' }}>
                                                    {email}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>

                                <Box
                                    sx={{
                                        background: `linear-gradient(135deg, ${primaryColor}08 0%, ${primaryColor}05 100%)`,
                                        borderRadius: '12px',
                                        padding: '12px 16px',
                                        marginTop: 2,
                                        border: `1px solid ${primaryColor}20`,
                                    }}
                                >
                                    <Typography sx={{ fontSize: '13px', color: '#5a5a5a', fontFamily: bodyFont, lineHeight: 1.6 }}>
                                        <EmailIcon sx={{ fontSize: 16, verticalAlign: 'text-bottom', marginRight: 0.5, color: primaryColor }} />
                                        Your eVoucher will be sent to <strong>{email}</strong> after successful payment
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>

                        {/* Payment Method Card */}
                        <Card
                            sx={{
                                background: '#fff',
                                borderRadius: { xs: '16px', md: '20px' },
                                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.06)',
                                border: `2px solid ${primaryColor}10`,
                            }}
                        >
                            <CardContent sx={{ padding: { xs: '20px', sm: '28px' } }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2 }, marginBottom: { xs: 2, sm: 3 } }}>
                                    <Box
                                        sx={{
                                            background: `linear-gradient(135deg, ${primaryColor}15 0%, ${primaryColor}08 100%)`,
                                            borderRadius: { xs: '10px', sm: '12px' },
                                            padding: { xs: '10px', sm: '12px' },
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Payment sx={{ fontSize: { xs: 24, sm: 28 }, color: primaryColor }} />
                                    </Box>
                                    <Typography
                                        sx={{
                                            color: headingsColor,
                                            fontSize: { xs: '16px', sm: '18px', md: '20px' },
                                            fontWeight: 700,
                                            fontFamily: headingsFont,
                                        }}
                                    >
                                        Payment Method
                                    </Typography>
                                </Box>

                                <FormControl fullWidth error={paymentMethodError}>
                                    <RadioGroup value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                                        {/* M-Pesa Option */}
                                        {mpesaStatus && (
                                            <Box
                                                sx={{
                                                    border: paymentMethod === 'mpesa' ? `2px solid ${primaryColor}` : '2px solid #e0e0e0',
                                                    borderRadius: `${buttonRadius}px`,
                                                    padding: { xs: '12px', sm: '16px' },
                                                    marginBottom: 2,
                                                    background: paymentMethod === 'mpesa' ? `linear-gradient(135deg, ${primaryColor}08 0%, ${primaryColor}05 100%)` : 'transparent',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s',
                                                    '&:hover': {
                                                        borderColor: primaryColor,
                                                        background: `linear-gradient(135deg, ${primaryColor}08 0%, ${primaryColor}05 100%)`,
                                                    },
                                                }}
                                                onClick={() => setPaymentMethod('mpesa')}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
                                                        <Radio
                                                            value="mpesa"
                                                            checked={paymentMethod === 'mpesa'}
                                                            sx={{
                                                                color: primaryColor,
                                                                padding: { xs: '6px', sm: '9px' },
                                                                '&.Mui-checked': { color: primaryColor },
                                                            }}
                                                        />
                                                        <img src={mpesaIcon} alt="M-Pesa" style={{ height: '22px', objectFit: 'contain' }} />
                                                    </Box>
                                                    {paymentMethod === 'mpesa' && <CheckCircle sx={{ color: primaryColor, fontSize: { xs: 18, sm: 20 } }} />}
                                                </Box>

                                                {paymentMethod === 'mpesa' && (
                                                    <Box sx={{ marginTop: 2, paddingLeft: { xs: '8px', sm: '52px' } }}>
                                                        <Typography sx={{ fontSize: { xs: '13px', sm: '14px' }, color: '#5a5a5a', marginBottom: 2, fontFamily: bodyFont }}>
                                                            Enter your M-Pesa phone number to receive STK push
                                                        </Typography>
                                                        <PhoneInput
                                                            country={'ke'}
                                                            value={mpesaPhoneNumber}
                                                            onChange={setMpesaPhoneNumber}
                                                            inputStyle={{
                                                                width: '100%',
                                                                height: '48px',
                                                                fontSize: '15px',
                                                                borderRadius: `${buttonRadius}px`,
                                                                border: mpesaPhoneNumberError ? '2px solid #ef0b0b' : '2px solid #e0e0e0',
                                                                fontFamily: bodyFont,
                                                            }}
                                                        />
                                                        {mpesaPhoneNumberError && (
                                                            <FormHelperText sx={{ color: '#ef0b0b', marginLeft: 0 }}>
                                                                Please enter a valid phone number (254...)
                                                            </FormHelperText>
                                                        )}
                                                    </Box>
                                                )}
                                            </Box>
                                        )}

                                        {/* Mobile Money Option */}
                                        {bankPaybillStatus && (
                                            <Box
                                                sx={{
                                                    border: paymentMethod === 'kcbpaybill' ? `2px solid ${primaryColor}` : '2px solid #e0e0e0',
                                                    borderRadius: `${buttonRadius}px`,
                                                    padding: { xs: '12px', sm: '16px' },
                                                    marginBottom: 2,
                                                    background: paymentMethod === 'kcbpaybill' ? `linear-gradient(135deg, ${primaryColor}08 0%, ${primaryColor}05 100%)` : 'transparent',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s',
                                                    '&:hover': {
                                                        borderColor: primaryColor,
                                                        background: `linear-gradient(135deg, ${primaryColor}08 0%, ${primaryColor}05 100%)`,
                                                    },
                                                }}
                                                onClick={() => setPaymentMethod('kcbpaybill')}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
                                                        <Radio
                                                            value="kcbpaybill"
                                                            checked={paymentMethod === 'kcbpaybill'}
                                                            sx={{
                                                                color: primaryColor,
                                                                padding: { xs: '6px', sm: '9px' },
                                                                '&.Mui-checked': { color: primaryColor },
                                                            }}
                                                        />
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
                                                            <Phone sx={{ color: primaryColor, fontSize: { xs: 20, sm: 24 } }} />
                                                            <Typography sx={{ fontSize: { xs: '14px', sm: '15px' }, fontWeight: 600, color: headingsColor, fontFamily: bodyFont }}>
                                                                Mobile Money
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    {paymentMethod === 'kcbpaybill' && <CheckCircle sx={{ color: primaryColor, fontSize: { xs: 18, sm: 20 } }} />}
                                                </Box>

                                                {paymentMethod === 'kcbpaybill' && (
                                                    <Box sx={{ marginTop: 2, paddingLeft: { xs: '8px', sm: '52px' } }}>
                                                        <Typography sx={{ fontSize: { xs: '13px', sm: '14px' }, color: '#5a5a5a', marginBottom: 2, fontFamily: bodyFont }}>
                                                            STK push will be sent to your phone
                                                        </Typography>
                                                        <PhoneInput
                                                            country={'ke'}
                                                            value={mobileMoneyNumber}
                                                            onChange={setMobileMoneyNumber}
                                                            inputStyle={{
                                                                width: '100%',
                                                                height: '48px',
                                                                fontSize: '15px',
                                                                borderRadius: `${buttonRadius}px`,
                                                                border: mobileMoneyNumberError ? '2px solid #ef0b0b' : '2px solid #e0e0e0',
                                                                fontFamily: bodyFont,
                                                            }}
                                                        />
                                                        {mobileMoneyNumberError && (
                                                            <FormHelperText sx={{ color: '#ef0b0b', marginLeft: 0 }}>
                                                                Please enter a valid phone number
                                                            </FormHelperText>
                                                        )}
                                                    </Box>
                                                )}
                                            </Box>
                                        )}

                                        {/* Card Payment Option */}
                                        {payCardStatus && (
                                            <Box
                                                sx={{
                                                    border: paymentMethod === 'card' ? `2px solid ${primaryColor}` : '2px solid #e0e0e0',
                                                    borderRadius: `${buttonRadius}px`,
                                                    padding: { xs: '12px', sm: '16px' },
                                                    background: paymentMethod === 'card' ? `linear-gradient(135deg, ${primaryColor}08 0%, ${primaryColor}05 100%)` : 'transparent',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s',
                                                    '&:hover': {
                                                        borderColor: primaryColor,
                                                        background: `linear-gradient(135deg, ${primaryColor}08 0%, ${primaryColor}05 100%)`,
                                                    },
                                                }}
                                                onClick={() => setPaymentMethod('card')}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
                                                        <Radio
                                                            value="card"
                                                            checked={paymentMethod === 'card'}
                                                            sx={{
                                                                color: primaryColor,
                                                                padding: { xs: '6px', sm: '9px' },
                                                                '&.Mui-checked': { color: primaryColor },
                                                            }}
                                                        />
                                                        <img src={cardIcon} alt="Card" style={{ height: '24px', objectFit: 'contain' }} />
                                                        <Typography sx={{ fontSize: { xs: '14px', sm: '15px' }, fontWeight: 600, color: headingsColor, fontFamily: bodyFont }}>
                                                            Credit/Debit Card
                                                        </Typography>
                                                    </Box>
                                                    {paymentMethod === 'card' && <CheckCircle sx={{ color: primaryColor, fontSize: { xs: 18, sm: 20 } }} />}
                                                </Box>

                                                {paymentMethod === 'card' && (
                                                    <Box sx={{ marginTop: 2, paddingLeft: { xs: '8px', sm: '52px' } }}>
                                                        <Typography sx={{ fontSize: { xs: '13px', sm: '14px' }, color: '#5a5a5a', fontFamily: bodyFont }}>
                                                            You will be redirected to a secure payment page
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        )}
                                    </RadioGroup>
                                    {paymentMethodError && (
                                        <FormHelperText sx={{ color: '#ef0b0b', marginTop: 1 }}>
                                            Please select a payment method
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Right Column - Order Summary */}
                    <Grid item xs={12} lg={5}>
                        <Box sx={{ position: { lg: 'sticky' }, top: { lg: '20px' } }}>
                            <Card
                                sx={{
                                    background: '#fff',
                                    borderRadius: { xs: '16px', md: '20px' },
                                    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.06)',
                                    border: `2px solid ${primaryColor}10`,
                                }}
                            >
                                <CardContent sx={{ padding: { xs: '20px', sm: '28px' } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2 }, marginBottom: { xs: 2, sm: 3 } }}>
                                        <Box
                                            sx={{
                                                background: `linear-gradient(135deg, ${primaryColor}15 0%, ${primaryColor}08 100%)`,
                                                borderRadius: { xs: '10px', sm: '12px' },
                                                padding: { xs: '10px', sm: '12px' },
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <LocalOffer sx={{ fontSize: { xs: 24, sm: 28 }, color: primaryColor }} />
                                        </Box>
                                        <Typography
                                            sx={{
                                                color: headingsColor,
                                                fontSize: { xs: '16px', sm: '18px', md: '20px' },
                                                fontWeight: 700,
                                                fontFamily: headingsFont,
                                            }}
                                        >
                                            Order Summary
                                        </Typography>
                                    </Box>

                                    {/* Voucher Details */}
                                    <Box
                                        sx={{
                                            background: `linear-gradient(135deg, ${primaryColor}15 0%, ${primaryColor}08 100%)`,
                                            borderRadius: '12px',
                                            padding: '20px',
                                            marginBottom: 3,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                fontWeight: 700,
                                                color: headingsColor,
                                                marginBottom: 1,
                                                fontFamily: headingsFont,
                                            }}
                                        >
                                            {voucherData?.voucherDetails?.name || voucherData?.voucherDetails?.campaignName}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: '13px',
                                                color: '#5a5a5a',
                                                fontFamily: bodyFont,
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            {voucherData?.voucherDetails?.description}
                                        </Typography>
                                    </Box>

                                    <Divider sx={{ marginY: 2 }} />

                                    {/* Price Breakdown */}
                                    <Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                                            <Typography sx={{ fontSize: '15px', color: '#707070', fontFamily: bodyFont }}>
                                                Voucher Amount
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 600, color: headingsColor, fontFamily: bodyFont }}>
                                                {currencyconverter(voucherData?.selectedVoucher?.voucherAmount)}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{ marginY: 2 }} />

                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
                                            <Typography sx={{ fontSize: '18px', fontWeight: 700, color: headingsColor, fontFamily: headingsFont }}>
                                                Total
                                            </Typography>
                                            <Typography sx={{ fontSize: '22px', fontWeight: 800, color: primaryColor, fontFamily: headingsFont }}>
                                                {currencyconverter(voucherData?.selectedVoucher?.voucherAmount)}
                                            </Typography>
                                        </Box>

                                        {/* Action Buttons */}
                                        <Button
                                            onClick={handleSubmit}
                                            disabled={buttonStatus}
                                            variant="contained"
                                            fullWidth
                                            sx={{
                                                background: buttonStatus
                                                    ? 'linear-gradient(135deg, #e0e0e0 0%, #d0d0d0 100%)'
                                                    : `linear-gradient(135deg, ${buttonPrimaryColor} 0%, ${buttonPrimaryColor}dd 100%)`,
                                                color: buttonStatus ? '#999' : '#fff',
                                                fontSize: '16px',
                                                fontWeight: 700,
                                                borderRadius: `${buttonRadius}px`,
                                                padding: '16px',
                                                textTransform: 'none',
                                                fontFamily: bodyFont,
                                                boxShadow: buttonStatus
                                                    ? 'none'
                                                    : `0 8px 24px ${buttonPrimaryColor}40`,
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                '&:hover': {
                                                    background: buttonStatus
                                                        ? 'linear-gradient(135deg, #e0e0e0 0%, #d0d0d0 100%)'
                                                        : `linear-gradient(135deg, ${buttonPrimaryColor}dd 0%, ${buttonPrimaryColor} 100%)`,
                                                    transform: buttonStatus ? 'none' : 'translateY(-2px)',
                                                    boxShadow: buttonStatus
                                                        ? 'none'
                                                        : `0 12px 32px ${buttonPrimaryColor}50`,
                                                },
                                                '&:disabled': {
                                                    cursor: 'not-allowed',
                                                },
                                            }}
                                        >
                                            Complete Payment
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>

                            {/* Security Notice */}
                            <Box
                                sx={{
                                    marginTop: 2,
                                    padding: '16px',
                                    background: 'rgba(0, 0, 0, 0.02)',
                                    borderRadius: '12px',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography sx={{ fontSize: '12px', color: '#707070', fontFamily: bodyFont, lineHeight: 1.6 }}>
                                    Your payment information is secure and encrypted. eVoucher will be sent immediately after successful payment.
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* Processing Modal */}
            <Modal
                open={openOrderProcessing}
                aria-labelledby="processing-modal"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        background: '#fff',
                        borderRadius: '20px',
                        boxShadow: '0 24px 64px rgba(0, 0, 0, 0.15)',
                        padding: '40px',
                        textAlign: 'center',
                        maxWidth: '400px',
                    }}
                >
                    <img
                        src={loadingIcon}
                        alt="Processing"
                        style={{
                            width: '120px',
                            height: '120px',
                            margin: '0 auto 20px',
                            animation: 'spin 2s linear infinite',
                        }}
                    />
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontWeight: 700,
                            color: headingsColor,
                            marginBottom: 1,
                            fontFamily: headingsFont,
                        }}
                    >
                        Processing Payment
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '14px',
                            color: '#707070',
                            fontFamily: bodyFont,
                            lineHeight: 1.6,
                        }}
                    >
                        {paymentMethod === 'card'
                            ? 'You will be redirected to complete payment'
                            : 'Please check your phone for STK prompt'}
                    </Typography>
                </Box>
            </Modal>

            {/* Success Modal */}
            <Modal
                open={showSuccessModal}
                aria-labelledby="success-modal"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        background: '#fff',
                        borderRadius: '20px',
                        boxShadow: '0 24px 64px rgba(0, 0, 0, 0.15)',
                        padding: { xs: '32px 24px', sm: '48px 40px' },
                        textAlign: 'center',
                        maxWidth: { xs: '90%', sm: '500px' },
                        position: 'relative',
                        overflow: 'hidden',
                    }}
                >
                    {/* Success Animation Background */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: -50,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 200,
                            height: 200,
                            borderRadius: '50%',
                            background: `radial-gradient(circle, ${primaryColor}15 0%, transparent 70%)`,
                            animation: 'pulse 2s ease-in-out infinite',
                        }}
                    />

                    {/* Success Icon */}
                    <Box
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: { xs: '80px', sm: '100px' },
                            height: { xs: '80px', sm: '100px' },
                            borderRadius: '50%',
                            background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`,
                            marginBottom: 3,
                            boxShadow: `0 8px 32px ${primaryColor}40`,
                            position: 'relative',
                            animation: 'scaleIn 0.5s ease-out',
                        }}
                    >
                        <CheckCircleOutline
                            sx={{
                                fontSize: { xs: 48, sm: 60 },
                                color: '#fff',
                            }}
                        />
                    </Box>

                    {/* Success Message */}
                    <Typography
                        sx={{
                            fontSize: { xs: '24px', sm: '28px' },
                            fontWeight: 800,
                            color: headingsColor,
                            marginBottom: 1.5,
                            fontFamily: headingsFont,
                        }}
                    >
                        Payment Successful!
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: { xs: '14px', sm: '15px' },
                            color: '#5a5a5a',
                            marginBottom: 3,
                            fontFamily: bodyFont,
                            lineHeight: 1.6,
                        }}
                    >
                        Your eVoucher purchase has been completed successfully
                    </Typography>

                    {/* Voucher Details Card */}
                    <Box
                        sx={{
                            background: `linear-gradient(135deg, ${primaryColor}10 0%, ${primaryColor}05 100%)`,
                            borderRadius: '12px',
                            padding: { xs: '16px', sm: '20px' },
                            marginBottom: 3,
                            border: `1px solid ${primaryColor}30`,
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, marginBottom: 1 }}>
                            <LocalOffer sx={{ fontSize: 20, color: primaryColor }} />
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    fontWeight: 700,
                                    color: headingsColor,
                                    fontFamily: headingsFont,
                                }}
                            >
                                {voucherData?.voucherDetails?.name || voucherData?.voucherDetails?.campaignName}
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                fontSize: '20px',
                                fontWeight: 800,
                                color: primaryColor,
                                fontFamily: headingsFont,
                            }}
                        >
                            {currencyconverter(voucherData?.selectedVoucher?.voucherAmount)}
                        </Typography>
                    </Box>

                    {/* What's Next Section */}
                    <Box
                        sx={{
                            background: 'rgba(0, 0, 0, 0.02)',
                            borderRadius: '12px',
                            padding: { xs: '16px', sm: '20px' },
                            marginBottom: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: 700,
                                color: headingsColor,
                                marginBottom: 1.5,
                                fontFamily: headingsFont,
                            }}
                        >
                            What's Next?
                        </Typography>
                        <Box sx={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                <CheckCircle sx={{ fontSize: 18, color: primaryColor, marginTop: '2px' }} />
                                <Typography sx={{ fontSize: '13px', color: '#5a5a5a', fontFamily: bodyFont, lineHeight: 1.5 }}>
                                    Check your email for the eVoucher code
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                <CheckCircle sx={{ fontSize: 18, color: primaryColor, marginTop: '2px' }} />
                                <Typography sx={{ fontSize: '13px', color: '#5a5a5a', fontFamily: bodyFont, lineHeight: 1.5 }}>
                                    Apply the code at checkout to redeem
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                <CheckCircle sx={{ fontSize: 18, color: primaryColor, marginTop: '2px' }} />
                                <Typography sx={{ fontSize: '13px', color: '#5a5a5a', fontFamily: bodyFont, lineHeight: 1.5 }}>
                                    Valid until the campaign expiry date
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Action Button */}
                    <Button
                        onClick={() => {
                            setShowSuccessModal(false);
                            setCheckout(false);
                            setVoucherData(null);
                            navigate(`/evouchers`);
                        }}
                        variant="contained"
                        fullWidth
                        sx={{
                            marginTop: 3,
                            background: `linear-gradient(135deg, ${buttonPrimaryColor} 0%, ${buttonPrimaryColor}dd 100%)`,
                            color: '#fff',
                            fontSize: '15px',
                            fontWeight: 700,
                            borderRadius: `${buttonRadius}px`,
                            padding: '14px',
                            textTransform: 'none',
                            fontFamily: bodyFont,
                            boxShadow: `0 6px 20px ${buttonPrimaryColor}40`,
                            '&:hover': {
                                background: `linear-gradient(135deg, ${buttonPrimaryColor}dd 0%, ${buttonPrimaryColor} 100%)`,
                                transform: 'translateY(-2px)',
                                boxShadow: `0 8px 24px ${buttonPrimaryColor}50`,
                            },
                        }}
                    >
                        Continue Shopping
                    </Button>
                </Box>
            </Modal>

            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                @keyframes scaleIn {
                    from {
                        transform: scale(0);
                        opacity: 0;
                    }
                    to {
                        transform: scale(1);
                        opacity: 1;
                    }
                }
                @keyframes pulse {
                    0%, 100% {
                        transform: translateX(-50%) scale(1);
                        opacity: 0.5;
                    }
                    50% {
                        transform: translateX(-50%) scale(1.1);
                        opacity: 0.8;
                    }
                }
            `}</style>
        </Box>
    )
}

export default EvoucherCheckout
